import React from 'react';
import * as Sentry from '@sentry/browser';
import './index.css';
import { Form, FormButton, FormTextArea, Header, Modal } from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import { postSentFeedbackError } from '../../util/api';


class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      isModalOpen: false,
      form: {
        name: '',
        email: '',
        text: ''
      }
    };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error, isModalOpen: false });
    console.log('sentry error', error);
    Sentry.withScope(scope => {
      Object.keys(errorInfo).forEach(key => {
        scope.setExtra(key, errorInfo[key]);
      });
      Sentry.captureException(error);
    });
  }
  handleChangeName = (event, { value }) => {
    this.setState(prevState => ({
      form: {
        ...prevState.form,
        name: value
      }
    }));
  };

  handleChangeEmail = (event, { value }) => {
    this.setState(prevState => ({
      form: {
        ...prevState.form,
        email: value
      }
    }));
  };

  handleChangeText = (event, { value }) => {
    this.setState(prevState => ({
      form: {
        ...prevState.form,
        text: value
      }
    }));
  };

  handleSubmit = event => {
    event.preventDefault();
    postSentFeedbackError(this.state.form).then(res => {
      if(res[1].success) {
        window.location.href = '/';
      } else {
        console.log(res);
      }
    })
  };

  render() {
    if (this.state.error) {
      const { t } = this.props;

      return (
        <div className="wrapper-btn-report">
          <button onClick={() => this.setState({isModalOpen: true})}>
            {t("feedback_form.btn_report")}
          </button>
          <Modal
            closeIcon
            size="small"
            className="feedback-form"
            open={this.state.isModalOpen}
            onClose={() => this.setState({ isModalOpen: false })}
          >
            <Header icon="file text outline" content={t("feedback_form.modal_header")} />
            <Modal.Content>
              <Form className="feedback-form" onSubmit={this.handleSubmit}>
                <Form.Group>
                  <Form.Input
                    width={9}
                    required
                    label={t("feedback_form.input_name")}
                    placeholder={t("feedback_form.input_name_placeholder")}
                    value={this.state.form.name}
                    onChange={this.handleChangeName}
                  />
                  <Form.Input
                    width={9}
                    required
                    label={t("feedback_form.input_email")}
                    placeholder={t("feedback_form.input_email_placeholder")}
                    value={this.state.form.email}
                    onChange={this.handleChangeEmail}
                  />
                </Form.Group>
                <FormTextArea
                  label={t("feedback_form.input_text")}
                  placeholder={t("feedback_form.input_text_placeholder")}
                  required
                  value={this.state.form.text}
                  onChange={this.handleChangeText}
                />
                <FormButton>{t("buttons.btn_submit")}</FormButton>
              </Form>
            </Modal.Content>
          </Modal>
        </div>
      );
    } else {
      return this.props.children;
    }
  }
}

export default withTranslation() (ErrorBoundary);
